"use client";

// Tiny mount-only client component, same pattern as DiagnosticsAutoFlushClient.
// Fires once per page load (not once per navigation, since Navbar/RootLayout
// re-renders server-side on every nav but this component only mounts once for
// the lifetime of the client-side React tree) — recordSiteVisit() itself is
// idempotent per rolling 24h via hasReceivedPointToday, so even a hard refresh
// landing here again is harmless. Renders nothing.

import { useEffect } from "react";
import { recordSiteVisit } from "../actions/activity";

export default function SiteVisitTracker() {
  useEffect(() => {
    recordSiteVisit();
  }, []);
  return null;
}
